// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"387":"234bde6a18eed0a2","498":"2f0226eb8a797772"}[chunkId] + ".js";
};